
const pathnameElements = window.location.pathname.split('/');

let area = 'DE';
let countrySelector = '';
if (pathnameElements.length >= 2) {
  switch (pathnameElements[1]) {
    case 'us':
      countrySelector = 'us';
      area = 'US';
      break;
    // Add new regions by checking their country selector
    default:
      countrySelector = '';
      area = 'DE';
  }
}

const getLocale = () => {
  let languageString;
  if (countrySelector !== '') {
    languageString = pathnameElements[2]; // eslint-disable-line prefer-destructuring
  } else if (pathnameElements.length >= 2) {
    languageString = pathnameElements[1]; // eslint-disable-line prefer-destructuring
  }
  if (
    languageString === 'de'
    || languageString === 'dk'
  ) {
    return languageString;
  }
  return 'en';
};

export const PAGE_AREA = area;
export const PAGE_LOCAL = getLocale();

console.log(PAGE_AREA);
console.log(PAGE_LOCAL);

export const HOST_SITE = window.location.hostname !== 'localhost'
  ? `https://${window.location.hostname}${countrySelector !== '' ? `/${countrySelector}` : ''}`
  : 'https://www.mksneezeguard.com';
export const ASSET_FOLDER = `${HOST_SITE}/wp-content/plugins/mk-configurator-plugin-vue/`;
export const SERVER_ADDRESS = 'https://configurator-backend.mksolutions.com';
export const PAGE_URL = `/${countrySelector !== '' ? `${countrySelector}/` : ''}${PAGE_LOCAL}/configurator/`;
export const WOOCOMMERCE_API_ADRESS = `${HOST_SITE}/${PAGE_LOCAL}/wp-json/wc/v3`;

export const WC_CUSTOMER_KEY = document.getElementById('mk-configurator').getAttribute('key');
export const WC_CUSTOMER_SECRET = document.getElementById('mk-configurator').getAttribute('sec');

export const TABLE_PLAIN = 'TABLE_PLAIN';
export const TABLE_CORNER = 'TABLE_CORNER';
export const TABLE_CORNER_LEFT = 'TABLE_CORNER_LEFT';
export const TABLE_UCORNER = 'TABLE_UCORNER';

export const ARROW_X = 'ARROW_X';
export const ARROW_Y = 'ARROW_Y';
export const ARROW_CHILD_ANGLE = 'ARROW_CHILD_ANGLE';
export const ARROW_CHILD_RADIUS = 'ARROW_CHILD_RADIUS';

export const ARROW_HEIGHT = 'ARROW_HEIGHT';
export const ARROW_RAISED_WIDTH = 'ARROW_RAISED_WIDTH';
export const ARROW_RAISED_HEIGHT = 'ARROW_RAISED_HEIGHT';

export const ARROW_OFFSET = 'ARROW_OFFSET';
